// extracted by mini-css-extract-plugin
export default {"row":"kpi_row__mAKKc","kpiValue":"kpi_kpiValue__C-mRC","card":"kpi_card__6Y6Sw"};